import { XmlSchemaFacet } from './XmlSchemaFacet';

export class XmlSchemaMaxLengthFacet extends XmlSchemaFacet {}
